import React from 'react';

import ClickableImage from '../ClickableImage/ClickableImage';

import styles from './HeaderSortIcons.module.scss';

type Props = {
  isAscending: boolean | null; // null = not sorted, true/false = sorted direction
  iconUpSrc: string;
  iconDownSrc: string;
  onClickUp: () => void;
  onClickDown: () => void;
};

const HeaderSortIcons: React.FC<Props> = ({
  isAscending,
  iconUpSrc,
  iconDownSrc,
  onClickUp,
  onClickDown,
}) => {
  const iconUpClassName = isAscending === true ? styles.iconUpActive : styles.iconUp;

  return (
    <div className={styles.wrapperIcons}>
      <div className={styles.icons}>
        <ClickableImage
          alt=""
          src={iconUpSrc}
          className={iconUpClassName}
          onClick={onClickUp}
        />
        <ClickableImage
          alt=""
          src={iconDownSrc}
          className={styles.iconDown}
          onClick={onClickDown}
        />
      </div>
    </div>
  );
};

export default HeaderSortIcons;
